import { render } from "./DashboardRes.vue?vue&type=template&id=deb84e58"
import script from "./DashboardRes.vue?vue&type=script&lang=js"
export * from "./DashboardRes.vue?vue&type=script&lang=js"

import "./DashboardRes.vue?vue&type=style&index=0&id=deb84e58&lang=scss"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__